import * as ADMIN_USERS_ACTION_TYPES from './constants';
import {
    LOGOUT
} from '../LoginPage/constants';

const initialState = {
    page: 1,
    filterByType: null,
    filterBySearch: '',
    users: [],
    usersTotal: 0,
    loading: false,
    loadingError: false,
}

const users = (state = initialState, {
    type,
    payload,
}) => {
    switch (type) {
        case ADMIN_USERS_ACTION_TYPES.SET_PAGE:
            return {
                ...state,
                page: payload,
            };

        case ADMIN_USERS_ACTION_TYPES.SET_FILTER_BY_SEARCH:
            return {
                ...state,
                filterBySearch: payload,
            };

        case ADMIN_USERS_ACTION_TYPES.SET_FILTER_BY_TYPE:
            return {
                ...state,
                filterByType: typeof payload === 'number' ? payload : null,
            };

        case ADMIN_USERS_ACTION_TYPES.SET_IS_LOADING:
            return {
                ...state,
                loading: typeof payload === 'boolean' ? payload : !state.loading,
            };

        case ADMIN_USERS_ACTION_TYPES.SET_LOADING_ERROR:
            return {
                ...state,
                loadingError: typeof payload === 'boolean' ? payload : !state.loadingError,
            };

        case ADMIN_USERS_ACTION_TYPES.SET_USERS:
            return {
                ...state,
                users: payload,
            };

        case ADMIN_USERS_ACTION_TYPES.SET_USERS_TOTAL:
            return {
                ...state,
                usersTotal: payload,
            };

        case LOGOUT:
            return initialState;

        default:
            return state;
    }
}

export default users;



// WEBPACK FOOTER //
// ./app/web/src/container/AdminUsersPage/reducer.js